export let appConfig = null;

export function initAppConfig() {
    appConfig = {
        "PUBLIC_URL": process.env.PUBLIC_URL,
        "basename": window.appConfig == null ? process.env.PUBLIC_URL : window.appConfig.BASENAME,
        ...(window.appConfig == null ? require(`./config/${process.env.REACT_APP_XSPORT_CUSTOMER}.conf.json`) : window.appConfig)
    };
    
    appConfig.ROUTES.routeFromPath = function(path) {
        var toReturn = null;
        Object.entries(appConfig.ROUTES).forEach(function([k, v]) {
            if (!(typeof v === 'function')) {
               if (Object.keys(v).find(k2 => v[k2] === path || v[k2] === `${path}/`)) {
                    toReturn =  k;
               }
               if (Object.keys(v).find(k2 => v[k2] === path ||  `${v[k2]}/` === path)) {
                toReturn =  k;
               }
            }
        });
        return toReturn;
    }
    
    appConfig.ROUTES.pathFromSection = function(route,section) {
        return appConfig.ROUTES[route][section];
    }
    
    appConfig.ROUTES.sectionFromPath = function(path,sections) {
        return Object.keys(sections).find(function(k) {
            return sections[k] === path || sections[k] === [path, '/'].join('') || [sections[k], '/'].join('') === path;
        });
    }

    appConfig.BASENAME = appConfig?.BASENAME ?? process.env.PUBLIC_URL;
    window.appConfig = appConfig;

    const bfInit = window.appConfig.HANDLERS?.['beforeInit'] ?? null;
    if (typeof bfInit === 'function') {
        bfInit();
    }
}
